// extracted by mini-css-extract-plugin
export default {"cls1":"News-cls1_cXw","cls2":"News-cls2_RMe News-cls1_cXw"};